<template>
  <div class="caseShow" >
    <!-- 标题图片 -->
    <div class="titleImg">
      <img src="../img/title.png" alt="">
    </div>
    <div class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/case' }" class="breadcrumbItem">客户案例</el-breadcrumb-item>
          <el-breadcrumb-item class="breadcrumbItem">案例详情</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <p class="titleText">{{caseInfo.Title}}</p>
    <div class="caseShowImg">
      <img v-lazy="caseInfo.TitlePic" :key="caseInfo.TitlePic" alt="">
      <!-- <img :src="item.TitlePic" alt=""> -->
    </div>
    <div class="caseShowInfo">
      <!-- <p class="infoTitle">客户简介：</p>
      <p class="infoText">河南德尔康医药科技有限公司坐落于千年帝都牡丹花城——洛阳。公司主要经营各类中西药品、中药饮片、医疗器械及保健食品等，满足各类医疗机构、社区医疗卫生服务机构、医药连锁公司总部及终端单体药店、诊所的日常经营需求。公司注册地址洛阳市洛龙区杜预街3号，注册资金壹亿元。现有员工500余人，平台合作业务成员1000多人，由全体员工持股的现代化医药科技经营企业。</p>
      <p class="infoTitle">签约产品：</p>
      <ul class="infoText">
        <li>德尔康终端</li>
        <li>电商全设备集成项目</li>
      </ul>
      <p class="infoTitle">带来的价值：</p>
      <p class="infoText">通过实施物流信息系统，德尔康医药建立了对仓储物流中心运作的精细化作业管理，作业效率和数据准确性得到很大的提高，极大提升了公司的客户满意度和公
司服务质量。</p>
      <p class="infoTitle">需求与挑战：</p>
      <ul class="infoText">
        <li>兼顾集团化统一管理，与各分公司个性化管理的需求</li>
        <li>化药、中药、生物药、医疗器械、保健药品，原辅料、成品、包材，制造、流通，多品类多模式业务</li>
        <li>堆垛机、输送线、机械手、AGV等各类自动化设备的高效应用</li>
        <li>未来的快速扩展</li>
      </ul> -->
      <div v-html="caseInfo.Content"></div>
    </div>
  </div>
</template>

<script>
// import { getSolveShow } from '@/api/solve'
// 引入时间格式过滤
// import { timeFormat } from '@/utils/myFilters'
// 引入根路径
// import request from '@/utils/request'
export default {
  data () {
    return {
      // solveShow: {} // 解决方案详情
    }
  },
  computed: {
    caseInfo () {
      return this.$store.state.caseInfo;//需要监听的数据
    }
  },
  filters: {
    // timeFormat
  },
  mounted () {
    // this.getSolveShow({ id: this.$route.params.id })
  },

  methods: {

  }

}
</script>

<style  lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.caseShow{
  width: 100%;
  overflow: hidden;
}
.titleImg{
  width: 100%;
  height: 460px*$sun;
  img{
    width: 100%;
    height: 100%;
  }
}
.title{
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #000;
    overflow: hidden;
    margin-bottom: 50px*$sun;
    .breadcrumb{
        padding: 0 360px*$sun;
        font-size: 24px*$sun;
        margin-top: 50px*$sun;
        font-weight: 500;
        .breadcrumbItem{
          font-weight: 500;
        }

    }
}

.titleText{
  font-size: 26px*$sun;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin: 0;
  margin-bottom: 60px*$sun;
}
.caseShowImg{
  width: 266px*$sun;
  height: 137px*$sun;
  margin: auto;
  margin-bottom: 60px*$sun;
  img{
    width: 100%;
    height: 100%;
  }
}
.caseShowInfo{
  width:1200px*$sun;
  margin: auto;
  margin-bottom: 140px*$sun;
  p{
    margin: 0;
  }
  .infoTitle{
    font-size: 22px*$sun;
    font-weight: bold;
    color: #333333;
    margin-bottom: 36px*$sun;
  }
  .infoText{
    font-size: 16px*$sun;
    font-weight: 500;
    line-height: 26px*$sun;
    color: #333333;
    letter-spacing: 1px*$sun;
    margin-bottom: 36px*$sun;
    li{
      margin-bottom: 25px*$sun;
    }
  }
}
</style>
